import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { NavController } from '@ionic/angular/standalone'
import { StoreSession } from 'src/app/store/store-session'

export const sessionGuard: CanActivateFn = async () => {
  const store = inject(StoreSession)
  const navController = inject(NavController)

  if (store.session().accessToken) {
    navController.navigateForward('solventa')
    return false
  }

  return true
}
